<template>
  <custom-dialog width="550px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-form-item :label="$t('info_dialog.yuan_gong_xing_ming')" prop="realName">
          <el-input v-model="form.realName" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('info_dialog.lian_xi_dian_hua')" prop="mobile">
          <el-input v-model="form.mobile" style="width:100%;"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="warning" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        realName: '',
        mobile: '',
        // email: ''
      },
      userInfo: {}
    };
  },
  computed: {
    rules() {
      return {
        realName: {
          required: true,
          message: this.$t('info_dialog.ygxmbt')
        },
        mobile: {
          required: true,
          message: this.$t('info_dialog.lxdhbt')
        },
      };
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.userInfo = this.model.userInfo;
      this.$setFormatData(this.form, this.userInfo);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.updateUserInfo();
      });
    },
    // 更新用户信息
    updateUserInfo: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserInfo, this.form)
          .then(() => {
            this.userInfo.realName = this.form.realName;
            this.userInfo.mobile = this.form.mobile;
            this.$store.commit('USERINFO', this.userInfo);
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.visible = false;
          })
          .catch(() => {});
      });
    }
  }
};
</script>

<style lang="scss"></style>
